import { useEffect, useRef } from 'react';

import Env from 'env';

import auth from '../auth';

import { useAuthSession } from './authSession';

// auth.login() se estaba ejecutando durante el render del componente:
// En React, el render debe ser puro. Si metes un efecto secundario ahí,
// React puede volver a renderizar y dispararlo otra vez.
// En desarrollo, StrictMode además puede volver a ejecutar
// componentes y efectos para detectar bugs; React documenta
// tanto el doble render de componentes como la
// re-ejecución adicional en desarrollo

interface Props {
  children: any;
}
const AuthRedirect = ({ children }: Props) => {
  const session = useAuthSession();
  const startedRef = useRef(false);
  const isCallbackRoute = window.location.pathname === '/auth/callback';

  useEffect(() => {
    if (Env.development) return;
    if (isCallbackRoute) return;
    if (session.status === 'logging-out') return;
    if (session.user) return;
    if (startedRef.current) return;

    startedRef.current = true;
    void auth.login();
  }, [session.user, isCallbackRoute]);

  if (isCallbackRoute) return children;

  if (session.status === 'logging-out') return null;
  if (Env.development) return children;

  if (!session.user) {
    return null;
  }

  return children;
};

export default AuthRedirect;
